const CryptoJS = require("crypto-js");

export const generateAesKey = (PasswordVal) => {
    try {
        const initVector = process.env.REACT_APP_VECTORKEY;
        const key = process.env.REACT_APP_SECRETKEY;
        const iv = CryptoJS.enc.Utf8.parse(initVector);
        const skeySpec = CryptoJS.enc.Utf8.parse(key);

        const encrypted = CryptoJS.AES.encrypt(
            PasswordVal,
            skeySpec,
            { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
        );
        return encrypted.toString();

    } catch (ex) {
        console.error(ex);
        return null;
    }
};

export const encryptPayload = (payload) => {
    const payloadString = JSON.stringify(payload);
    const encrypted = CryptoJS.AES.encrypt(payloadString, process.env.REACT_APP_SECRETKEY).toString();
    return encrypted;
};

export const decryptPayload = (encryptedPayload) => {
    const bytes = CryptoJS.AES.decrypt(encryptedPayload, process.env.REACT_APP_SECRETKEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    const decryptedPayload = JSON.parse(decryptedString);
    return decryptedPayload;
  };

export const HSdecrypt = (encrypted, key, initVector) => {
    try {
      // Decode the Base64 encrypted string
      const encryptedBytes = CryptoJS.enc.Base64.parse(encrypted);
  
      // Create the key and IV for decryption
      const keyBytes = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRETKEY);
      const ivBytes = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_VECTORKEY);
  
      // Perform the decryption
      const decryptedBytes = CryptoJS.AES.decrypt(
        { ciphertext: encryptedBytes },
        keyBytes,
        {
          iv: ivBytes,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
  
      // Convert the decrypted bytes to a string
      const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
  
      return decryptedText;
    } catch (error) {
      console.error('Decryption error:', error);
      return null;
    }
  };


